/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BodyDataExport,
  HTTPValidationError,
  ResourceType,
} from '../models/index';
import {
    BodyDataExportFromJSON,
    BodyDataExportToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    ResourceTypeFromJSON,
    ResourceTypeToJSON,
} from '../models/index';

export interface DataExportRequest {
    resourceType: ResourceType;
    sortLabel?: string;
    sortDesc?: boolean;
    bodyDataExport?: BodyDataExport;
}

/**
 * 
 */
export class DataExportApi extends runtime.BaseAPI {

    /**
     * Export filtered list of the requested resource as an XLSX file
     */
    async dataExportRaw(requestParameters: DataExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.resourceType === null || requestParameters.resourceType === undefined) {
            throw new runtime.RequiredError('resourceType','Required parameter requestParameters.resourceType was null or undefined when calling dataExport.');
        }

        const queryParameters: any = {};

        if (requestParameters.resourceType !== undefined) {
            queryParameters['resource_type'] = requestParameters.resourceType;
        }

        if (requestParameters.sortLabel !== undefined) {
            queryParameters['sort_label'] = requestParameters.sortLabel;
        }

        if (requestParameters.sortDesc !== undefined) {
            queryParameters['sort_desc'] = requestParameters.sortDesc;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/data-export`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BodyDataExportToJSON(requestParameters.bodyDataExport),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Export filtered list of the requested resource as an XLSX file
     */
    async dataExport(requestParameters: DataExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.dataExportRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
